// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tn-reading-progress {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  z-index: 9700;
  pointer-events: none;
  background: transparent;
}

.tn-reading-progress__fill {
  height: 100%;
  background: linear-gradient(90deg, #00a896, #00d4aa);
  transform-origin: left center;
  transform: scaleX(0);
  will-change: transform;
  transition: transform 0.1s linear;
}

@media print {
  .tn-reading-progress { display: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/ReadingProgressBar/ReadingProgressBar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,6BAA6B;EAC7B,oBAAoB;EACpB,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,uBAAuB,aAAa,EAAE;AACxC","sourcesContent":[".tn-reading-progress {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  z-index: 9700;\n  pointer-events: none;\n  background: transparent;\n}\n\n.tn-reading-progress__fill {\n  height: 100%;\n  background: linear-gradient(90deg, #00a896, #00d4aa);\n  transform-origin: left center;\n  transform: scaleX(0);\n  will-change: transform;\n  transition: transform 0.1s linear;\n}\n\n@media print {\n  .tn-reading-progress { display: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
